/**
 * Blocked — 451 geo-block page. Standalone (no auth chrome).
 */
import { Link } from "react-router-dom";
import { AlertOctagon, Mail } from "lucide-react";

export default function Blocked() {
  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center px-6 text-center relative overflow-hidden bg-[color:var(--bg-base)] text-[color:var(--text-primary)]"
      data-testid="blocked-page"
    >
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 -left-40 w-[600px] h-[600px] bg-pink-glow" />
        <div className="absolute bottom-0 -right-40 w-[500px] h-[500px] bg-gold-glow" />
      </div>

      <div className="relative z-10">
        <Link to="/" className="inline-flex items-center gap-3 mb-12" data-testid="blocked-logo">
          <span className="h-10 w-10 rounded-lg bg-brand-gradient flex items-center justify-center font-display italic text-white text-xl shadow-glow-pink">B</span>
          <span className="font-display italic text-lg text-ink">Bra Game</span>
        </Link>

        <div className="inline-flex items-center gap-2 mb-6 px-4 py-1.5 rounded-full border border-danger/40 bg-danger/10">
          <AlertOctagon className="w-3.5 h-3.5 text-danger" />
          <span className="text-[10px] tracking-[0.4em] uppercase text-danger">451 · Unavailable For Legal Reasons</span>
        </div>

        <h1 className="font-display italic text-5xl sm:text-6xl text-ink leading-[1.05] max-w-2xl">
          This service is not <span className="gradient-text">available</span> in your region.
        </h1>

        <p className="text-base text-ink-2 mt-6 max-w-md mx-auto leading-relaxed">
          Bra Game is licensed under the Anjouan Gaming Authority and cannot be offered to players in your country.
          If you believe this is an error, contact support.
        </p>

        <div className="mt-10 flex flex-wrap gap-3 items-center justify-center">
          <a
            href="mailto:support@bragame.local"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg border border-line text-ink-2 hover:text-ink hover:border-pink text-sm transition"
            data-testid="blocked-support-link"
          >
            <Mail className="w-3.5 h-3.5" />
            Contact support
          </a>
          <a
            href="https://www.google.com"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-elevated border border-line text-ink hover:brightness-110 text-sm transition"
            data-testid="blocked-exit-link"
          >
            Exit
          </a>
        </div>

        <div className="mt-16 text-[10px] tracking-[0.35em] uppercase text-ink-3">
          © 2026 Bra Game N.V. · Anjouan License #ALSI-XXXXXX-XX
        </div>
      </div>
    </div>
  );
}
